import { getCookie } from '@api/HelperAPI';
import { useSplitTestBranch } from '@api/lendingAPI/lapiHooks';

export const DE_REPAYMENT_REDUCTION_TEST = 'de_repayment_reduction_test_2025';
export const SHOW_REPAYMENT_REDUCTION_PREVIEW_COOKIE =
    'showRepaymentReductionPreview';

export const useIsInDERepaymentReductionTest = (): boolean => {
    const isPreviewEnabled =
        getCookie(SHOW_REPAYMENT_REDUCTION_PREVIEW_COOKIE) === 'true';

    const { branch } = useSplitTestBranch({
        test: DE_REPAYMENT_REDUCTION_TEST,
        suspense: true,
        enabled: isPreviewEnabled
    });

    return isPreviewEnabled && branch === 'INCLUDE';
};
